import styled from "styled-components";
import {RouterOutletDefaultBox} from "./router-outlet.default.box";
import {baseColors} from "../../../themes/definitions/casino888/base-colors";

export const RouterOutletCasino888Box = styled(RouterOutletDefaultBox)`
    background-color: ${baseColors.gray013};
    background-image: linear-gradient(180deg, #1A1A1A 74.08%, #282828 100%);
    background-attachment: fixed;
`